import { render, staticRenderFns } from "./GlobalFn.vue?vue&type=template&id=43ca9054&scoped=true"
import script from "./GlobalFn.vue?vue&type=script&lang=js"
export * from "./GlobalFn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca9054",
  null
  
)

export default component.exports